import type { SVGProps } from 'react';
const DawnFlagMZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MZ_svg__a)">
      <path fill="#FFE547" d="M0 16h22v-4.267H0z" />
      <path fill="#118C81" d="M0 4.267h22V0H0z" />
      <path fill="#fff" d="M0 11.733h22V4.267H0z" />
      <path fill="#262626" d="M0 10.667h22V5.333H0z" />
      <path fill="#EF2147" d="m0 0 10.476 8L0 16z" />
      <path
        fill="#FDE444"
        d="m3.667 9.02-1.54 1.137.588-1.842-1.539-1.14h1.902l.589-1.842.588 1.842h1.903l-1.539 1.14.587 1.842z"
      />
    </g>
  </svg>
);
export default DawnFlagMZ;
